module.exports = __webpack_public_path__ + "img/list_icon3.38aa09d5.png";